import { render, staticRenderFns } from "./ed-tabs-header-menu.vue?vue&type=template&id=e083f140&scoped=true&"
import script from "./ed-tabs-header-menu.ts?vue&type=script&lang=ts&"
export * from "./ed-tabs-header-menu.ts?vue&type=script&lang=ts&"
import style0 from "./ed-tabs-header-menu.scss?vue&type=style&index=0&id=e083f140&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e083f140",
  null
  
)

export default component.exports